import AppContext from "PFApp/app_context";
import usePageWrapper from "PFCore/helpers/use_page_wrapper";
import React, { useContext } from "react";

import Approvals from "./approvals";
import useApprovalsTab from "./use_approvals_tab";

const ApprovalsTab = () => {
  useApprovalsTab();
  const {
    store: {
      pages: {
        booking: { approvals }
      }
    }
  } = useContext(AppContext);
  const WrappedTab = usePageWrapper(Approvals);

  return <WrappedTab loading={!approvals} />;
};

export default ApprovalsTab;
